var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notData"}},[_c('div',{staticClass:"img-view"},[(_vm.img)?[_c('img',{attrs:{"src":_vm.img,"alt":""}})]:_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"24px"}},[_vm._v(_vm._s(_vm.topTitle))]),_vm._v(" "),(_vm.bottomTitle)?[_c('span',[_vm._v(_vm._s(_vm.bottomTitle))])]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134191ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/noData.vue
// module id = null
// module chunks = 